// Universal UI constants
 
export const SELECT_TEXT_COLOR_DARK = '#fff';
export const SELECT_BG_COLOR_DARK = '#222';

// Primary Colors
export const PRIMARY_PINK = '#e91e63';
export const PRIMARY_PINK_DARK = '#c2185b';

// Status Colors
export const SUCCESS_GREEN = '#4caf50';
export const WARNING_ORANGE = '#ff9800';

// Background Colors
export const BACKGROUND_DARK = '#121212';
export const BACKGROUND_LIGHT = '#f5f5f5';
export const PAPER_DARK = '#1e1e1e';
export const PAPER_LIGHT = '#ffffff';
export const CARD_DARK = '#2d2d2d';
export const CARD_LIGHT = '#f5f5f5';

// Text Colors
export const TEXT_PRIMARY_DARK = '#ffffff';
export const TEXT_PRIMARY_LIGHT = '#000000';
export const TEXT_SECONDARY_DARK = '#b0b0b0';
export const TEXT_SECONDARY_LIGHT = '#666666';

// Border Colors
export const BORDER_DARK = '#404040';
export const BORDER_LIGHT = '#e0e0e0';

// Accent Colors
export const BLUE_ACCENT = '#90caf9';
export const BLUE_PRIMARY = '#1976d2';
export const BLUE_LIGHT = '#e3f2fd';
export const BLUE_DARK = '#1a3f5c';

// Transparent Colors
export const TRANSPARENT_WHITE_10 = 'rgba(255, 255, 255, 0.1)';
export const TRANSPARENT_WHITE_12 = 'rgba(255, 255, 255, 0.12)';
export const TRANSPARENT_WHITE_23 = 'rgba(255, 255, 255, 0.23)';
export const TRANSPARENT_WHITE_40 = 'rgba(255, 255, 255, 0.4)';
export const TRANSPARENT_WHITE_70 = 'rgba(255, 255, 255, 0.7)';
export const TRANSPARENT_WHITE_75 = 'rgba(255, 255, 255, 0.75)';
export const TRANSPARENT_WHITE_80 = 'rgba(255, 255, 255, 0.8)';
export const TRANSPARENT_WHITE_90 = 'rgba(255, 255, 255, 0.9)';

export const TRANSPARENT_BLACK_04 = 'rgba(0, 0, 0, 0.04)';
export const TRANSPARENT_BLACK_08 = 'rgba(0, 0, 0, 0.08)';
export const TRANSPARENT_BLACK_12 = 'rgba(0, 0, 0, 0.12)';
export const TRANSPARENT_BLACK_23 = 'rgba(0, 0, 0, 0.23)';
export const TRANSPARENT_BLACK_40 = 'rgba(0, 0, 0, 0.4)';
export const TRANSPARENT_BLACK_50 = 'rgba(0, 0, 0, 0.5)';
export const TRANSPARENT_BLACK_60 = 'rgba(0, 0, 0, 0.6)';

export const TRANSPARENT_PINK_05 = 'rgba(233, 30, 99, 0.05)';
export const TRANSPARENT_PINK_08 = 'rgba(233, 30, 99, 0.08)';
export const TRANSPARENT_PINK_1 = 'rgba(233, 30, 99, 0.1)';
export const TRANSPARENT_PINK_2 = 'rgba(233, 30, 99, 0.2)';
export const TRANSPARENT_PINK_3 = 'rgba(233, 30, 99, 0.3)';
export const TRANSPARENT_PINK_5 = 'rgba(233, 30, 99, 0.5)';

export const TRANSPARENT_GRAY_30 = 'rgba(30, 30, 30, 0.8)';
export const TRANSPARENT_GRAY_80 = 'rgba(30, 30, 30, 0.8)';

// Shadow Colors
export const SHADOW_BLACK_15 = 'rgba(0, 0, 0, 0.15)';
export const SHADOW_BLACK_30 = 'rgba(0, 0, 0, 0.3)';
export const SHADOW_BLACK_10 = 'rgba(0, 0, 0, 0.1)';

// Theme-specific colors
export const DARK_THEME_BACKGROUND = '#1e1e1e';
export const DARK_THEME_PAPER = '#1e1e1e';
export const LIGHT_THEME_BACKGROUND = '#f5f5f5';
export const LIGHT_THEME_PAPER = '#ffffff'; 